<template>
  <label class="flex flex-col gap-2">
    <span
      class="font-helvetica text-[16px] leading-[24px]"
      :class="error ? 'text-orange' : 'text-gray-dark'"
    >
      {{ label }}
    </span>
    <input
      :type="type"
      :inputmode="inputmode"
      class="w-full h-[48px] rounded-[10px] border px-4 text-[16px] font-helvetica transition-colors"
      :class="[
        error ? 'border-orange' : 'border-gray-dark',
        'focus:border-orange focus:outline-none',
      ]"
      :placeholder="placeholder"
      :value="modelValue"
      @input="handleInput"
      @blur="$emit('blur')"
    />
    <p v-if="error" class="text-orange text-[12px] leading-[16px]">
      {{ error }}
    </p>
  </label>
</template>

<script setup lang="ts">
type InputMode =
  | "none"
  | "text"
  | "tel"
  | "url"
  | "email"
  | "numeric"
  | "decimal"
  | "search";

const props = withDefaults(
  defineProps<{
    modelValue: string;
    label: string;
    placeholder?: string;
    type?: string;
    inputmode?: InputMode;
    error?: string;
    formatter?: (value: string) => string;
  }>(),
  { type: "text", placeholder: "", inputmode: undefined, formatter: undefined }
);

const emit = defineEmits<{
  (event: "update:modelValue", value: string): void;
  (event: "blur"): void;
}>();

const handleInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  if (props.formatter) {
    const formatted = props.formatter(value);
    if (formatted !== value) {
      input.value = formatted;
    }
    value = formatted;
  }
  emit("update:modelValue", value);
};
</script>
